import { Component, OnInit } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { BedComponent } from 'src/app/models/components/objectComponents/BedComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { Shelf } from 'src/app/models/other/shelf.model';
import { Box } from 'src/app/models/other/box.model';
import { BaseDimensionComponent } from 'src/app/models/components/commonComponents/BaseDimensionComponent';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-bed',
  templateUrl: './bed.component.html',
  styleUrls: ['./bed.component.scss']
})
export class BedViewComponent extends BaseAdvancedPropertyViewComponent {
  bed: BedComponent;
  bedBase: BaseDimensionComponent;
  amountOfPeopleList: number[] = [1, 2, 3, 4];
  shelfArr: Array<Shelf> = new Array<Shelf>();
  isRemoveShelfDisabled: boolean = true;
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    setTimeout(() => {
      this.bed = getComponentFromSource(ComponentNames.bedComponent, this.items);
      this.bedBase = getComponentFromSource(ComponentNames.baseDimensionsComponent, this.items);
      this.shelfArr = this.bed.shelves;
      this.changeIsRemoveShelfDisabled();
    }, 0);
  }

  saveButtonDisabledState(): boolean {
    let disable = false;

    if (this.baseDimension.box.height < 0)
      disable = true;
    if (this.amountOfPeopleList.length < 0)
      disable = true;
    if (this.shelfArr.length === 0)
      disable = true;
    if (this.validateShelfInputs() === false)
      disable = true;

    return disable;
  }
  changeAmountOfPeopleList(selectedValue: number) {
    this.bed.amountOfPeople = selectedValue;
  };

  addShelf() {
    let shelf: Shelf = JSON.parse(JSON.stringify(this.shelfArr[this.shelfArr.length - 1]));
    this.shelfArr.push(shelf);
    this.changeIsRemoveShelfDisabled();
  }

  validateShelfInputs(): boolean {
    let valid = true;
    let factorClearWidth: number = 1.1; //10% mehr
    let factorDepthOfCompartment: number = 1.25; //25% mehr
    let totalWidth: number = 0;


    for (let index = 0; index < this.shelfArr.length; index++) {
      const elementLeft = this.shelfArr[index];

      if (elementLeft.box.length < 1 || elementLeft.box.length > (this.bedBase.box.width * factorDepthOfCompartment))
        valid = false;
      if (elementLeft.box.height < 1)
        valid = false;
      if (elementLeft.box.width < 1)
        valid = false;

      totalWidth += elementLeft.box.width;

      if (!valid)
        break;

    }
    //Shelf zusammenzählen, da sie nebeneinander sind
    if ((valid && this.bedBase != undefined) && (totalWidth > (this.bedBase.box.length * factorClearWidth)
    )) {
      valid = false;
    }

    return valid;
  }

  removeShelf() {
    if (this.shelfArr.length > 1) {
      this.shelfArr.pop();
    }
    this.changeIsRemoveShelfDisabled();
  }

  changeIsRemoveShelfDisabled() {
    if (this.shelfArr.length > 1) {
      this.isRemoveShelfDisabled = false;
    }
    else {
      this.isRemoveShelfDisabled = true;
    }
  }
}
